<template style="padding: 15px">
  <div style="display: flex; flex-direction: row; gap: 10px">
    <div class="widget-resume">
      <div class="number bg-green">{{ qtdProfAtivo }}</div>
      <div class="label">Profisionais de saúde ativos</div>
    </div>
    <div class="widget-resume">
      <div class="number bg-blue">{{ qtdPacAtivo }}</div>
      <div class="label">Pacientes ativos</div>
    </div>
  </div>

  <div style="display: flex; flex-direction: row; gap: 10px; margin-top: 10px">
    <div class="widget-resume">
      <div class="number bg-orange">{{ qtdAtendimento.qtdAtendimentoAgendado }}</div>
      <div class="label">Atendimentos Agendados</div>
    </div>
    <div class="widget-resume">
      <div class="number bg-green">{{ qtdAtendimento.qtdAtendimentoRealizado }}</div>
      <div class="label">Atendimentos Realizados</div>
    </div>
    <div class="widget-resume">
      <div class="number bg-red">{{ qtdAtendimento.qtdAtendimentoFaltaJustificada }}</div>
      <div class="label">Não compareceu - Falta Justificada</div>
    </div>
    <div class="widget-resume">
      <div class="number bg-red">{{ qtdAtendimento.qtdAtendimentoFaltaInjustificada }}</div>
      <div class="label">Não compareceu - Falta Injustificada</div>
    </div>
  </div>
  <div class="row" style="margin-top: 10px">
    <a-collapse v-model:activeKey="activeKey">
      <a-collapse-panel key="1" header="Relatórios">
        <div class="grid-container">
          <div class="grid-item" @click="openComponent(1)">
            <i class="fa-sharp fa-solid fa-user-doctor icons-list"></i>
            <span class="label-list">Profissionais</span>
          </div>
          <div class="grid-item" @click="openComponent(2)">
            <i class="fa-solid fa-chart-column icons-list"></i>
            <span class="label-list">Quantidade de Profissional por Tipo</span>
          </div>
          <div class="grid-item" @click="openComponent(3)">
            <i class="fa-solid fa-square-poll-vertical icons-list"></i>
            <span class="label-list">Quantidade de Atendimento por Profissional</span>
          </div>
          <div class="grid-item" @click="openComponent(4)">
            <i class="fa-solid fa-pen-to-square icons-list"></i>
            <span class="label-list">Quantidade de Atendimento por Categoria</span>
          </div>
          <div class="grid-item" @click="openComponent(5)">
            <i class="fa-solid fa-user-nurse icons-list"></i>
            <span class="label-list">Quantidade de Atendimento Paciente</span>
          </div>
          <div class="grid-item" @click="openComponent(6)">
            <i class="fa-solid fa-user-injured icons-list"></i>
            <span class="label-list">Pacientes</span>
          </div>
          <div class="grid-item" @click="openComponent(7)">
            <i class="fa-solid fa-square-poll-horizontal icons-list"></i>
            <span class="label-list">Quantidade de Atendimento por convênio</span>
          </div>
          <div class="grid-item" @click="openComponent(8)">
            <i class="fa-solid fa-chart-area icons-list"></i>
            <span class="label-list">Quantidade de Atendimento por Unidade de Atendimento</span>
          </div>
          <div class="grid-item" @click="openComponent(9)">
            <i class="fa-solid fa-paste icons-list"></i>
            <span class="label-list">Quantidade de Atendimento por Função atual</span>
          </div>
          <div class="grid-item" @click="openComponent(10)">
            <i class="fa-regular fa-newspaper icons-list"></i>
            <span class="label-list">Pacientes por convênio</span>
          </div>
          <div class="grid-item" @click="openComponent(11)">
            <i class="fa-regular fa-newspaper icons-list"></i>
            <span class="label-list">Atendimentos Por Situação</span>
          </div>
        </div>
      </a-collapse-panel>
    </a-collapse>
  </div>

  <div class="row" style="margin-top: 20px">
    <component v-bind:is="profissionaisRelatorio" v-if="prof"></component>
    <component v-bind:is="profTipoRelatorio" v-if="qtdProfTipo"></component>
    <component v-bind:is="atendimentoProfRelatorio" v-if="qtdAtenProf"></component>
    <component v-bind:is="atendimentoCategoriaRelatorio" v-if="qtdAtenCat"></component>
    <component v-bind:is="atendimentoPacienteRelatorio" v-if="qtdAtenPac"></component>
    <component v-bind:is="pacientesRelatorio" v-if="pac"></component>
    <component v-bind:is="atendimentoConvenioRelatorio" v-if="qtdAtenConv"></component>
    <component v-bind:is="atendimentoUnidadeRelatorio" v-if="qtdAtendUnid"></component>
    <component v-bind:is="atendimentoFuncaoAtualRelatorio" v-if="qtdAtenFuncAtual"></component>
    <component v-bind:is="pacienteConvenioRelatorio" v-if="pacConv"></component>
    <component v-bind:is="atendimentoSituacaoAgendamentoRelatorio" v-if="pacSituacaoAtendimento"></component>
  </div>
</template>

<script>
import AtendimentoCategoriaRelatorio from '@/components/pages/pages-relatorios/AtendimentoCategoriaRelatorio';
import AtendimentoConvenioRelatorio from '@/components/pages/pages-relatorios/AtendimentoConvenioRelatorio';
import AtendimentoFuncaoAtualRelatorio from '@/components/pages/pages-relatorios/AtendimentoFuncaoAtualRelatorio';
import AtendimentoPacienteRelatorio from '@/components/pages/pages-relatorios/AtendimentoPacienteRelatorio';
import AtendimentoProfRelatorio from '@/components/pages/pages-relatorios/AtendimentoProfRelatorio';
import AtendimentoSituacaoAgendamentoRelatorio from '@/components/pages/pages-relatorios/AtendimentoSituacaoAgendamentoRelatorio.vue';
import AtendimentoUnidadeRelatorio from '@/components/pages/pages-relatorios/AtendimentoUnidadeRelatorio';
import PacienteConvenioRelatorio from '@/components/pages/pages-relatorios/PacienteConvenioRelatorio';
import PacientesRelatorio from '@/components/pages/pages-relatorios/PacientesRelatorio';
import ProfTipoRelatorio from '@/components/pages/pages-relatorios/ProfTipoRelatorio';
import RelatorioProfissionais from '@/components/pages/pages-relatorios/RelatorioProfissionais';
import { getQtdAtendimentos } from '@/components/service/agendamento-medico';
import { getQtdPacAtivo } from '@/components/service/pacienteService';
import { getQtdProfissionalAtivo } from '@/components/service/profissionalService';

export default {
  name: 'DashboardRelatorio',
  components: {
    RelatorioProfissionais,
    ProfTipoRelatorio,
    AtendimentoProfRelatorio,
    AtendimentoCategoriaRelatorio,
    AtendimentoPacienteRelatorio,
    PacientesRelatorio,
    AtendimentoConvenioRelatorio,
    AtendimentoUnidadeRelatorio,
    AtendimentoFuncaoAtualRelatorio,
    PacienteConvenioRelatorio,
    AtendimentoSituacaoAgendamentoRelatorio,
  },
  data() {
    return {
      qtdProfAtivo: 0,
      qtdPacAtivo: 0,
      qtdAtendimento: { qtdAtendimentoRealizado: 0, qtdAtendimentoFaltaJustificada: 0, qtdAtendimentoFaltaInjustificada: 0, qtdAtendimentoAgendado: 0 },
      activeKey: 1,
      profissionaisRelatorio: RelatorioProfissionais,
      profTipoRelatorio: ProfTipoRelatorio,
      atendimentoProfRelatorio: AtendimentoProfRelatorio,
      atendimentoCategoriaRelatorio: AtendimentoCategoriaRelatorio,
      atendimentoPacienteRelatorio: AtendimentoPacienteRelatorio,
      pacientesRelatorio: PacientesRelatorio,
      atendimentoConvenioRelatorio: AtendimentoConvenioRelatorio,
      atendimentoUnidadeRelatorio: AtendimentoUnidadeRelatorio,
      atendimentoFuncaoAtualRelatorio: AtendimentoFuncaoAtualRelatorio,
      pacienteConvenioRelatorio: PacienteConvenioRelatorio,
      atendimentoSituacaoAgendamentoRelatorio: AtendimentoSituacaoAgendamentoRelatorio,
      prof: false,
      qtdProfTipo: false,
      qtdAtenProf: false,
      qtdAtenCat: false,
      qtdAtenPac: false,
      pac: false,
      qtdAtenConv: false,
      qtdAtendUnid: false,
      qtdAtenFuncAtual: false,
      pacConv: false,
      pacSituacaoAtendimento: false,
    };
  },
  async created() {
    await getQtdProfissionalAtivo().then((r) => {
      this.qtdProfAtivo = r.data;
    });

    await getQtdPacAtivo().then((r) => {
      this.qtdPacAtivo = r.data;
    });

    await getQtdAtendimentos().then((r) => {
      this.qtdAtendimento = r.data;
    });
  },
  methods: {
    openComponent(component) {
      this.activeKey = 0;
      this.resetComponents();
      switch (component) {
        case 1:
          this.prof = true;
          break;
        case 2:
          this.qtdProfTipo = true;
          break;
        case 3:
          this.qtdAtenProf = true;
          break;
        case 4:
          this.qtdAtenCat = true;
          break;
        case 5:
          this.qtdAtenPac = true;
          break;
        case 6:
          this.pac = true;
          break;
        case 7:
          this.qtdAtenConv = true;
          break;
        case 8:
          this.qtdAtendUnid = true;
          break;
        case 9:
          this.qtdAtenFuncAtual = true;
          break;
        case 10:
          this.pacConv = true;
          break;
        case 11:
          this.pacSituacaoAtendimento = true;
          break;
      }
    },
    resetComponents() {
      this.prof = false;
      this.qtdProfTipo = false;
      this.qtdAtenProf = false;
      this.qtdAtenCat = false;
      this.qtdAtenPac = false;
      this.pac = false;
      this.qtdAtenConv = false;
      this.qtdAtendUnid = false;
      this.qtdAtenFuncAtual = false;
      this.pacConv = false;
      this.pacSituacaoAtendimento = false;
    },
  },
};
</script>

<style scoped>
.icons-list {
  transition: transform 0.2s;
  cursor: pointer;
}

.icons-list:hover {
  color: #03315f;
  text-shadow: 0 0 3px #03315f;
  transform: scale(1.1);
}

.widget-resume {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 0px;
  background-color: #e0e0e0;
  margin: 0px;
  padding: 0px;
  flex: 1;
}

.label {
  padding: 0px 15px;
  line-height: 1.5;
  font-size: 16px;
  text-align: left;
  font-weight: bold;
  flex: 3;
  text-align: center;
}

.number {
  padding: 15px;
  font-size: 24px;
  flex: 1;
  text-align: center;
}

.bg-green {
  background: #99c940;
  color: white;
}

.bg-blue {
  background: #325ce3;
  color: white;
}

.bg-orange {
  background: #e8a200;
  color: white;
}

.bg-red {
  background: red;
  color: white;
}

.grid-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: start;
  align-items: stretch;
  align-content: stretch;
}

.grid-item {
  margin: 20px auto;
  width: 160px;
  height: 170px;
  background: #dddcdc;
  text-align: center;
  align-content: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  border-radius: 10px;
  border: 1px solid #909090;
  padding: 10px;
}

.icons-list {
  font-size: 36px;
  margin-bottom: 10px;
}

.label-list {
  font-size: 16px;
}
</style>
